<h2 class="row space-between align-center">
    <div>
        @if (isNew === true) {
            <span>New </span>
        } @else {
            <span>Edit </span>
        }
        @if (subOrganisation === true) {
            Sub-
        }
        Organisation
    </div>
    <rr-icon name="close" class="pointer" (click)="cancel($event)"></rr-icon>
</h2>
<div class="formarea col gap-16">
    <div class="row gap-8 company-logo">
        <app-company-logo
            [company]="data"
            [base64]="croppedImage"
            class="logo"
        ></app-company-logo>
        <rr-icon
            name="edit"
            class="edit"
            routerLink="/home/companies"
            [queryParams]="{ 'edit-logo': true }"
        ></rr-icon>
    </div>
    <h3>Main data</h3>
    <div class="lane row gap-8 align-end w100">
        <rr-select
            label="Parent Organisation"
            *ngIf="subOrganisation === true"
            [options]="organisations"
            optionName="path"
            optionValue="companyId"
            [(ngModel)]="company.value.parentId"
            [preselectedValue]="company.value.parentId"
        ></rr-select>
    </div>
    <div class="lane row gap-8 align-end w100">
        <rr-input
            label="Name"
            [(ngModel)]="company.value.name"
            [required]="true"
        ></rr-input>
        <rr-select
            label="Company type"
            [options]="companyTypes"
            optionName="name"
            optionValue="id"
            [(ngModel)]="company.value.companyTypeId"
            [required]="true"
            [preselectedValue]="company.value.companyTypeId"
        ></rr-select>
        <rr-select
            label="Industry"
            [options]="industries"
            optionName="name_en"
            optionValue="id"
            [(ngModel)]="company.value.industryId"
            [required]="true"
            [preselectedValue]="company.value.industryId"
        ></rr-select>
        <rr-select
            label="Status"
            [options]="statusList"
            optionName="name"
            optionValue="id"
            [(ngModel)]="company.value.status"
            [preselectedValue]="company.value.status"
            [required]="true"
        ></rr-select>
    </div>
    <div class="lane col gap-8 align-start w100">
        <rr-input
            label="Webpage"
            [(ngModel)]="company.value.webpage"
        ></rr-input>
        <rr-textarea
            label="Mission"
            [(ngModel)]="company.value.mission"
        ></rr-textarea>
    </div>
    <div class="lane col gap-8 align-start w100">
        <h3>Licenses Configuration</h3>
        <rr-checkbox
            [(ngModel)]="company.value.makesPayment"
            [checked]="company.value.makesPayment"
            >This Company makes the Payment for all Child-Companies and
            Users.</rr-checkbox
        >
        @if (
            company.value.companyTypeId === "9FnB5tXz" ||
            company.value.companyTypeId === "Zq4RfVbN"
        ) {
            <rr-checkbox
                [(ngModel)]="company.value.userGates"
                [checked]="company.value.userGates"
                >Validation Gates for Users (by Coach)</rr-checkbox
            >
            <rr-checkbox
                [(ngModel)]="company.value.customLoginForm"
                [checked]="company.value.customLoginForm"
                >Custom Login-Forms</rr-checkbox
            >
        }
        <rr-select
            label="Licenses"
            [options]="licenses"
            optionValue="id"
            optionName="name"
            [required]="true"
            [(ngModel)]="company.value.licenseTypeId"
            [preselectedValue]="company.value.licenseTypeId"
            (ngModelChange)="onLicenseChange($event)"
        ></rr-select>
        <div class="row gap-8" *ngIf="selectedLicense">
            <rr-input
                label="Credits"
                type="number"
                hint="For unlimited Credits set to -1"
                [(ngModel)]="selectedLicense.credits"
                [disabled]="
                    selectedLicense.id == 'INDIVIDUAL'
                        ? false
                        : selectedLicense.id == 'COMPANY'
                          ? false
                          : true
                "
            ></rr-input>
            <rr-input
                label="Seats"
                type="number"
                hint="For unlimited Seats set to -1"
                [(ngModel)]="selectedLicense.sublicense.count"
                [disabled]="
                    selectedLicense.id == 'INDIVIDUAL'
                        ? false
                        : selectedLicense.id == 'COMPANY'
                          ? false
                          : true
                "
            ></rr-input>
            <rr-input
                label="Max Role Level"
                type="number"
                [(ngModel)]="selectedLicense.sublicense.maxRoleLevel"
                [disabled]="true"
            ></rr-input>
        </div>
    </div>
    <div class="streameditarea col gap-8 w100">
        <h3>Stream Configuration</h3>
        <div class="col gap-16 w100">
            <div
                class="row gap-8 space-between streamitem w100"
                *ngFor="let stream of company.value.privateStreams"
            >
                <div class="row gap-8 align-center">
                    <rr-icon name="wind" class="" color="nutral"></rr-icon>
                    <span class="streamname">{{
                        getNameOfStream(stream)
                    }}</span>
                </div>
                <rr-icon
                    name="close"
                    class="pointer"
                    (click)="removeStream(stream)"
                ></rr-icon>
            </div>
            <div class="row gap-8 align-center w100">
                <rr-select
                    [options]="globalStreams"
                    [(ngModel)]="selectedStream"
                    optionValue="id"
                    optionName="name"
                    class="w100"
                ></rr-select>
                <rr-btn size="Medium" type="Secondary" (click)="addStream()"
                    >Add</rr-btn
                >
            </div>
        </div>
    </div>
    <div class="btnrow row justify-end w100 gap-8">
        <rr-btn size="Medium" type="Secondary" (click)="cancel($event)"
            >Cancel</rr-btn
        >
        <rr-btn
            size="Medium"
            iconStart="save"
            type="Primary"
            (click)="saveCompany()"
            >Save</rr-btn
        >
    </div>
</div>
<rr-spinner *ngIf="loading"></rr-spinner>
